module.exports = __webpack_public_path__ + "img/荣誉证书10_质量管理体系认证证书.850904bc.png";